import { Box, Divider, LinearProgressBar, Text } from '@wix/design-system';
import { useTranslation } from '@wix/fe-essentials/react';
import React from 'react';
import { dataHooks } from '../../../../../../../exports/testkit';
import { AltTextSummary } from '../../../alt-text-summary/alt-text-summary';
import { useAltTextScreenContext } from '../../alt-text-screen-wrapper';
import GenerateWithAiButton from './generate-with-ai-button';
export const AltTextOverviewSection = _ref => {
  let {
    totalAmount
  } = _ref;
  const {
    t
  } = useTranslation();
  const {
    state: {
      filledAmount,
      shouldShowSummary,
      isLoading
    }
  } = useAltTextScreenContext();
  const missingAmount = totalAmount - filledAmount;
  return /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    width: "100%"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "vertical",
    gap: "SP1",
    padding: "SP2 SP4 SP3 SP4"
  }, /*#__PURE__*/React.createElement(Box, {
    direction: "horizontal",
    gap: "SP2",
    justifyItems: "space-between",
    width: "100%",
    inline: true
  }, /*#__PURE__*/React.createElement(Box, {
    width: "100%"
  }, /*#__PURE__*/React.createElement(LinearProgressBar, {
    dataHook: dataHooks.altTextOverviewSectionProgressBar,
    padding: "none",
    skin: "success",
    value: filledAmount / totalAmount * 100
  })), /*#__PURE__*/React.createElement(Box, {
    marginLeft: "auto",
    marginTop: "SP1",
    minWidth: "fit-content"
  }, /*#__PURE__*/React.createElement(Text, {
    size: "tiny",
    weight: "thin"
  }, t('accessibility-wizard.alt-text.overview-section.progress-bar.filled', {
    filledAmount,
    totalAmount
  })))), /*#__PURE__*/React.createElement(Text, {
    dataHook: dataHooks.altTextOverviewSectionDescription,
    size: "tiny",
    weight: "thin"
  }, t('accessibility-wizard.alt-text.overview-section.progress-bar.description')), !isLoading && !shouldShowSummary && /*#__PURE__*/React.createElement(GenerateWithAiButton, {
    missingAmount: missingAmount,
    totalAmount: totalAmount
  }), shouldShowSummary && /*#__PURE__*/React.createElement(AltTextSummary, null)), /*#__PURE__*/React.createElement(Divider, null));
};
//# sourceMappingURL=alt-text-overview-section.js.map